import React, { useState } from 'react';
import { Dialog, DialogContent } from '@radix-ui/react-dialog';
import '@radix-ui/themes/styles.css';
import ReceivedBadgesModal from './ReceivedBadgeModal';

const enumBadgesType = {
  TEAM_PLAYER: 'Team Player',
  EXEMPLARY_LEADER: 'Exemplary Leader',
  TOP_CONTRIBUTOR: 'Top Contributor',
  BRILLIANT_EFFORT: 'Brilliant Effort',
  CREATIVE_THINKER: 'Creative Thinker',
  STAR_PARTICIPANT: 'Star Participant',
};

const BadgesData = [
  { id: 1, name: enumBadgesType.TEAM_PLAYER, title: 'Team Player' },
  { id: 2, name: enumBadgesType.EXEMPLARY_LEADER, title: 'Exemplary Leader' },
  { id: 3, name: enumBadgesType.TOP_CONTRIBUTOR, title: 'Top Contributor' },
  { id: 4, name: enumBadgesType.BRILLIANT_EFFORT, title: 'Brilliant Effort' },
  { id: 5, name: enumBadgesType.CREATIVE_THINKER, title: 'Creative Thinker' },
  { id: 6, name: enumBadgesType.STAR_PARTICIPANT, title: 'Star Participant' },
];

const BadgesModal = ({
  visible,
  onRequestClose,
  onSwipeDown,
  onPressShareImage,
  onShowReceivedModal,
  session_id,
  messageCount,
  consoleDetailData,
}) => {
  const renderBadges = (name) => {
    switch (name) {
      case enumBadgesType.TEAM_PLAYER:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badges/teamPlayer.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
      case enumBadgesType.EXEMPLARY_LEADER:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badges/exemplaryLeader.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
      case enumBadgesType.TOP_CONTRIBUTOR:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badges/topContributor.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
      case enumBadgesType.BRILLIANT_EFFORT:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badges/brilliantEffort.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
      case enumBadgesType.CREATIVE_THINKER:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badges/creativeThinker.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
      case enumBadgesType.STAR_PARTICIPANT:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badges/starParticipant.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
      default:
        return (
          <div
            className="bg-cover bg-center"
            style={{
              backgroundImage: `url(/assets/badgeImage.png)`,
              height: '25%',
              width: '25%',
            }}
          />
        );
    }
  };

  const [selectedTab, setSelectedTab] = useState(1);
  const [getSelectionMode, setSelectionMode] = useState(1);

  return (
    <div className="flex-1" onMouseDown={onSwipeDown}>
      <Dialog open={visible} onOpenChange={onRequestClose}>
        <DialogContent className="fixed top-[12%] bg-[#5B5D6B] rounded-t-[30px] flex-grow w-full max-w-full">
          <div className="flex flex-row">
            <button
              className={`flex items-center justify-center rounded-t-[1.5%] py-[1.5%] w-1/2 ${getSelectionMode === 1 ? 'bg-[#5F488A]' : 'bg-gray-300'}`}
              onClick={() => setSelectionMode(1)}
            >
              <span
                className={`px-[4%] text-[15px] ${getSelectionMode === 1 ? 'text-white font-bold' : 'text-[#5F488A] font-normal'}`}
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                Badges You Can Share
              </span>
            </button>
            <button
              className={`flex items-center justify-center rounded-t-[1.5%] w-1/2 ${getSelectionMode === 2 || getSelectionMode === 3 ? 'bg-[#5F488A]' : 'bg-gray-300'}`}
              onClick={() => setSelectionMode(2)}
            >
              <span
                className={`px-[4%] text-[15px] ${getSelectionMode === 2 || getSelectionMode === 3 ? 'text-white font-bold' : 'text-[#5F488A] font-normal'}`}
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                Badges You Received
              </span>
            </button>
          </div>

          {getSelectionMode === 1 ? (
            <div className="flex-1">
              <div className="grid grid-cols-2 gap-4 justify-items-center mt-[2%]">
                {BadgesData.map((item) => (
                  <div key={item.id} className="flex flex-col items-center">
                    {renderBadges(item?.name)}
                    <button
                      className="relative right-[-2%]"
                      onClick={() => onPressShareImage(item)}
                    >
                      <div className="flex flex-row items-center justify-center border border-black rounded-lg bg-white w-[50%] relative left-[-15px] top-[-20px]">
                        <img
                          src="/assets/share.png"
                          alt="Share"
                          className="object-contain left-[-10px]"
                          style={{ height: '5%', width: '10%' }}
                        />
                        <span
                          className="text-[#5F488A] text-base italic text-center left-[-15px]"
                          style={{ fontFamily: "'Lato', sans-serif" }}
                        >
                          Share
                        </span>
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ) : getSelectionMode === 2 ? (
            <div className="flex-1">
              <ReceivedBadgesModal />
            </div>
          ) : null}

          {/* <Footer
            navigation={navigation}
            session_id={session_id}
            consoleDetailData={consoleDetailData}
            orientation={undefined}
            messageCount={messageCount}
          /> */}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default BadgesModal;